import React, { useState } from "react";
import Layout from '../components/Layouts/Layout'
import data from "../data/images.json";
import Modal from "../components/Modal";
import '../styles/Style.css'
import { Container, Row, Col } from 'react-bootstrap'
import { ASSET_URL } from "../config/config";





const Media = () => {

  const [clickedImg, setClickedImg] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleClick = (item, index) => {
    setCurrentIndex(index);
    setClickedImg(item.link);
  };

  const handelRotationRight = () => {
    const totalLength = data.data.length;
    if (currentIndex + 1 >= totalLength) {
      setCurrentIndex(0);
      const newUrl = data.data[0].link;
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex + 1;
    const newUrl = data.data.filter((item) => {
      return data.data.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0].link;
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };

  const handelRotationLeft = () => {
    const totalLength = data.data.length;
    if (currentIndex === 0) {
      setCurrentIndex(totalLength - 1);
      const newUrl = data.data[totalLength - 1].link;
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex - 1;
    const newUrl = data.data.filter((item) => {
      return data.data.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0].link;
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };


  return (
        <>
            <Layout>
                <section className='media-header-bg header-bg' style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), url(${ASSET_URL}assets/images/sliders/media.webp)`}}>
                    <Container>
                        <Row>
                            <Col sm={12} lg={5}>
                                <div className="title">
                                    <h1 className="title-heading fs-3 mb-1">
                                    <span>Media</span></h1>
                                    <p className="title-desc">Stay updated on our latest events, new installations, media stories and more…</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <Container style={{padding:'50px 0'}}>
                  <Row>
                    <Col className="d-flex">
                  {data.data.map((item, index) => (
                    <div key={index} className="wrapper-images">
                      <img
                        src={item.link}
                        alt={item.text}
                        onClick={() => handleClick(item, index)}
                      />
                      {/* <h2>{item.text}</h2> */}
                    </div>
                  ))}
                  <div>
                    {clickedImg && (
                      <Modal
                        clickedImg={clickedImg}
                        handelRotationRight={handelRotationRight}
                        setClickedImg={setClickedImg}
                        handelRotationLeft={handelRotationLeft}
                      />
                    )}
                  </div>
                    </Col>
                  </Row>
                </Container>
            </Layout>
        </>
  )
}

export default Media